import { TRarity, TSchemaName } from "@pro/common/conf";
import classNames from "classnames";
import { observer } from "mobx-react";
import React, { ReactNode, useCallback, useEffect, useMemo, useState } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { appStore } from "../../../App";
import {
	AssetSortedTemplateType2,
	CustomTSchema,
	getAllBadges,
} from "../../../hooks/useCards";
import Styles from "../../../pages/game/cards.module.scss";
import { StakedAssetModel } from "../../../stores/StakedAssetModel";
import { Dropdown } from "../Dropdown";
import { GameAssetsTabsBar } from "../GameAssetsTabsBar";
import { AssetListView } from "./AssetListView";
import { PacksListView } from "./PacksListView";

export type AssetExaminerMode = "ALL" | "ONLY_STAKED"

export type AssetExaminerPropsType = {
	mode: AssetExaminerMode
	assetsToShow: AssetSortedTemplateType2
	activeCard?: StakedAssetModel
	setActiveCard?: (card: StakedAssetModel | undefined) => void
}

const DEFAULT_TABS: TSchemaName[] = ["symbols", "books", "heroes"]
const ALL_TABS: TSchemaName[] = ["symbols", "books", "heroes", "packs"]

export const AssetExaminer = observer(({ assetsToShow, mode } : AssetExaminerPropsType) => {
	const setActiveCard = appStore.setActiveCard;

	const activeDropdown = appStore.activeDropdown;
	const setDropdown = appStore.setActiveDropdown;

	const activeTab = appStore.activeTab;
	const setActiveTab = appStore.setActiveTab;

	const [TABS, setTabs] = useState(DEFAULT_TABS)

	const onTab = useCallback((tab) => {
		setActiveTab(tab);
		setDropdown('all');
		setActiveCard(null);
	}, [])
	const onDropdown = useCallback((dropdown) => {
		setDropdown(dropdown);
		setActiveCard(null);
	}, [])

	const badges = getAllBadges(assetsToShow[activeTab as CustomTSchema] || [])

	useEffect(() => {
		if (mode === 'ALL') {
			setTabs(ALL_TABS)
		}
	}, [])

	const getMemoAssets = useMemo(() => (schema: CustomTSchema) => {
		return (assetsToShow[schema] || [])[activeDropdown as TRarity | 'all']
	}, [
		activeDropdown,
		assetsToShow.symbols,
		assetsToShow.heroes,
		assetsToShow.books])

	return (
		<>
			<GameAssetsTabsBar activeOption={activeTab} options={TABS} onClick={onTab} />
			{activeTab !== 'packs' && <Dropdown options={badges} activeOption={activeDropdown} onChange={onDropdown} />}

			<Tabs
				selectedIndex={TABS.indexOf(activeTab as TSchemaName)}
				className={classNames(Styles.styleReactTabs, mode === "ALL" ? Styles.styleReactTabsCards : Styles.styleReactTabsHome)}
				selectedTabPanelClassName={Styles.styleReactTabsSpecificTab}
				onSelect={() => {}}
			>
				<TabList className={Styles.noDefaultTabList}>
					<Tab />
					<Tab />
					<Tab />
					{TABS.length === 4 && <Tab />}
				</TabList>
				<TabPanel key={`tab-pane-1`}>
					<AssetListView assets={getMemoAssets("symbols")} mode={mode} />
				</TabPanel>
				<TabPanel key={`tab-pane-2`}>
					<AssetListView assets={getMemoAssets("books")} mode={mode} />
				</TabPanel>
				<TabPanel key={`tab-pane-3`}>
					<AssetListView assets={getMemoAssets("heroes")} mode={mode} />
				</TabPanel>
				{TABS.length === 4 && <TabPanel key={`tab-pane-4`}>
					{mode === "ALL" && <PacksListView />}
				</TabPanel>}
			</Tabs>
		</>
	)
})




